<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="title" />
    <div v-emoji="description" class="t" />
    <donut-modal-sections-actions
      button-text="Send another"
      cancel-text="Close"
      save-mutation="updateModal"
      :save-args="state.modal.data.reopenModalArgs"
    />
  </div>
</template>

<script setup>
  import { inject } from 'vue';
  import { useStore } from 'vuex';
  import _ from 'lodash';

  const $i18n = inject('$i18n');
  const { state } = useStore();

  const { recipients, pointsPhrase, sendAs } = state.modal.data;
  const recipientPhrase = () => {
    const names = recipients.map(r => r.name);
    if (names.length === 1) return names[0];
    if (names.length === 2) return names.join(' and ');
    names[names.length - 1] = `and ${names.length - 1}`;
    return names.join(', ');
  };
  const shoutoutNoun = $i18n.t('shoutouts.shoutout', { count: recipients.length === 1 ? 1 : 2 });
  const title = `${_.capitalize(shoutoutNoun)} sent!`;
  const description = `${recipientPhrase()} just got your ${shoutoutNoun} and ${pointsPhrase}${recipients.length > 1 ? 'each' : ''}, `
   + `delivered ${recipients.length === 1 ? 'as a DM' : 'as separate DMs'} from ${sendAs === 'donut' ? 'Donut' : 'you'}.`;
</script>
